import { AuthGuard } from './guards/auth.guard';
import { TutorialGuard } from './guards/tutorial.guard';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/auth/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'tutorial',
    loadChildren: () =>
      import('./tutorial/tutorial.module').then((m) => m.TutorialPageModule),
  },
  {
    path: 'aboutus',
    loadChildren: () =>
      import('./pages/public/aboutus/aboutus.module').then(
        (m) => m.AboutusPageModule
      ),
  },

  {
    path: 'home',
    loadChildren: () =>
      import('./pages/private/home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard, TutorialGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./pages/private/admin/dashboard/dashboard.module').then(
        (m) => m.DashboardPageModule
      ),
    canActivate: [AuthGuard, TutorialGuard],
  },

  {
    path: 'policy',
    loadChildren: () =>
      import('./pages/public/policy/policy.module').then(
        (m) => m.PolicyPageModule
      ),
  },
  {
    path: 'carepackage-admin',
    loadChildren: () =>
      import(
        './pages/private/admin/carepackage-admin/carepackage-admin.module'
      ).then((m) => m.CarepackageAdminPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'carepackage-public',
    loadChildren: () =>
      import(
        './pages/public/carepackage-public/carepackage-public.module'
      ).then((m) => m.CarepackagePublicPageModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
